import type { LucideProps } from "lucide-react"

export function HaystackIcon(props: LucideProps) {
  return (
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.8 91.2" {...props}>
      <style>{`.haystack__st0{fill:#FFA726;}.haystack__st1{fill:#F57C00;}`}</style>
      <g>
        <g>
          <path
            className="haystack__st0"
            d="M88.8,61c-5.7-13.4-15.4-24.7-27.6-32.4C52.5,15.2,39.3,5,23.7,0c7.1,5.6,13,12.5,17.6,20.3C27,20.4,13.7,24.7,2.6,32.1c5.7-1.5,11.8-2.3,18-2.3c1.5,0,3.2,0.1,4.7,0.2C12.6,40,3.4,54.4,0,70.8c3-4.3,6.4-8.1,10.2-11.6c-2.4,7.1-3.7,14.6-3.7,22.5c10.4,6,22.5,9.5,35.4,9.5s25-3.5,35.4-9.5c0-12.4-2.5-24.1-7.1-34.8C77.2,50.5,83.5,55.3,88.8,61z"
          />
          <path
            className="haystack__st1"
            d="M25.5,48.2c-5.6,3-10.7,6.6-15.3,10.9c-0.2,0.6-3.7,10-3.7,22.5C9.5,68.4,16.2,57.5,25.5,48.2z"
          />
          <path
            className="haystack__st1"
            d="M17.8,36.8C24.2,34.2,31,32.6,38,32c-4.2-1.1-8.4-1.7-12.7-2C22.6,32.1,20.1,34.4,17.8,36.8z"
          />
          <path
            className="haystack__st1"
            d="M56.9,41.6c4.6,1.3,9,3,13.2,5.2c4.7,11,7.1,22.9,7.1,34.8C75,66.4,68,52.3,56.9,41.6z"
          />
          <path
            className="haystack__st1"
            d="M36.3,20.5c1.6-0.1,3.3-0.2,5-0.2c2.1,3.7,1.5,2.5,3.5,7.2C40.4,23.4,40.7,24.1,36.3,20.5z"
          />
        </g>
      </g>
    </svg>
  )
}
